import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ProfileService } from "../../services/profile.service";
import { CommonService } from "../../services/common.service";
import { Broadcaster } from "../../app.broadcaster";
import { EventPrefixValue, LoginEventName } from "../../app.config";
import { HttpClient } from "@angular/common/http";

declare var $: any;

@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.css"],
  providers: [ProfileService],
})
export class MenuComponent implements OnInit {
  title: string;
  anonymousUser: boolean;
  eventPrefixValue = EventPrefixValue;
  introduction: any;
  isSettingClicked: boolean;
  loginEventName = LoginEventName;
  callback: any;

  constructor(
    public commonService: CommonService,
    private httpClient: HttpClient,
    private profileService: ProfileService,
    private broadcaster: Broadcaster,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.broadcaster.broadcast("setBgOrNot", true);
    this.profileService.logOut(false);
    this.commonService.createSafeCss();
    this.broadcaster.on<boolean>("menuchange").subscribe((response) => {
      this.init();
      $("li a").unbind("mouseenter mouseleave");
    });
    this.broadcaster.on<boolean>("isSettingClicked").subscribe((response) => {
      this.isSettingClicked = response;
    });
    this.route.queryParams.subscribe((params: any) => {
      this.callback = params["isTab"];
      this.title = "";
    });
  }

  ngOnInit() {
    this.init();
  }

  init() {
    if (this.router.url.indexOf("home") !== -1) {
      this.title = "home";
    } else if (this.router.url.indexOf("contest") !== -1) {
      this.title = "contest";
    } else if (this.router.url.indexOf("wallet") !== -1) {
      this.title = "profile";
    } else if (this.router.url.indexOf("more") !== -1) {
      this.title = "more";
    }
    let url = "en";
    if (localStorage.getItem("saveLanguage")) {
      url = JSON.parse(localStorage.getItem("saveLanguage")).language;
    }
    if (!this.commonService.label) {
      this.httpClient
        .request("get", "assets/language/" + url + ".json?ver=3.13")
        .subscribe((response): any => {
          this.commonService.label = response;
          this.introduction = this.commonService.getHomeCoachMark();
        });
    } else {
      this.introduction = this.commonService.getHomeCoachMark();
    }
  }

  eventCall(title: string) {
    localStorage.removeItem("playingMode");

    const name =
      title === "contest"
        ? "MyContest"
        : title === "profile"
        ? "Wallet"
        : title === "refer"
        ? "Refer-N-Earn"
        : title;
    const capitalizedName =
      name.charAt(0).toUpperCase() + name.substr(1).toLowerCase();

    this.commonService.logEvent(
      EventPrefixValue.mainTabClicked,
      { TabName: capitalizedName },
      EventPrefixValue.home
    );
    this.commonService.logEvent(
      EventPrefixValue.screenLoadDone,
      {},
      capitalizedName
    );
  }
}
